var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWavesPageIntro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 142,
    viewBox: "0 0 1920 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.325057C0 0.325057 192.815 131.955 378 110.325C519.552 93.7914 545.516 24.9389 688 22C793.209 19.8299 925.288 83.3818 1030.5 81.3251C1129.59 79.3881 1172.04 5.66464 1271 0.325057C1406.65 -6.99396 1465.16 111.725 1601 110.325C1732.77 108.967 1920 0.325057 1920 0.325057V155H0V0.325057Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavesPageIntro);
export default __webpack_public_path__ + "static/media/wavesPageIntro.4db669ae5c20bb0f58f203a3d9a01cf4.svg";
export { ForwardRef as ReactComponent };